/**
 * Wingman Environment Configuration
 * Central authority for gateway URLs and asset paths.
 */

export const ENV = {
    // 🌐 GATEWAY AUTHORITY
    GATEWAY_URL: import.meta.env.VITE_GATEWAY_URL || 'http://localhost:3000',
    
    // 🧪 VERSIONING
    VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0-dev',
    
    // 🛡️ MODE
    IS_PROD: import.meta.env.PROD,
    IS_DEV: import.meta.env.DEV,
    
    // 🗺️ API TOKENS (PASSED FROM VITE)
    MAPBOX_TOKEN: import.meta.env.VITE_MAPBOX_TOKEN || '',
    GOOGLE_MAPS_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',

    // 🎙️ VOICE MODEL AUTHORITY
    GEMINI_API_KEY: import.meta.env.VITE_GEMINI_API_KEY || '', // 06V1-D3B2: hard-coded key removed; Gemini Live uses ephemeral tokens (D3)
    GEMINI_LIVE_MODEL: import.meta.env.VITE_GEMINI_LIVE_MODEL || 'gemini-3.1-flash-live-preview'
};
